interface Config {
  isDevelopment: boolean;
  apiUrl: string;
  customerIdentificationServiceUrl: string;
  myPageLink: string;
  chatLink: string;
  environment: 'prod' | 'uat' | 'dev';
  sanityDataset: 'prod' | 'uat';
}

interface RemoteConfig {
  launchDarklyClientId: string;
}

const hostname = globalThis.location?.hostname;
const config: Config = {
  isDevelopment: import.meta.env.DEV,
  environment: hostname === 'bestill.rikstv.no' ? 'prod' : hostname === 'bestill.uat.rikstv.no' ? 'uat' : 'dev',
  apiUrl: import.meta.env.VITE_API_API_URL || '/api',
  myPageLink: 'https://minside.rikstv.no/',
  chatLink: 'https://www.rikstv.no/chat/',
  customerIdentificationServiceUrl: 'https://integration-vipps.uat.rikstv.no/1',
  sanityDataset: hostname === 'bestill.rikstv.no' ? 'prod' : 'uat',
};

export default config;

export const getLDConfig = async (): Promise<RemoteConfig> => {
  return new Promise((resolve) => {
    let launchDarklyClientId = '6708c59830431f083bb4a5bd'; // dev
    switch (config.environment) {
      case 'prod':
        launchDarklyClientId = '6708c551b923000862bf3d98';
        break;
      case 'uat':
      case 'dev':
        launchDarklyClientId = '6708c58254760f0874a43847';
        break;
    }
    resolve({ launchDarklyClientId });
  });
};
